import React, { useEffect, useState } from 'react';
import useAdsAnalysis from './useAdsAnalysis';
import NoDataFound from '../NoDataFound/NoDataFound';
import { useOption } from '../../../../context/OptionContext';
import KpiAccordion from '../DashboardHome/KpiCard';
import { usePermissions } from '../../../../context/PermissionContext';
import AllowedCard from '../../../../common/AllowedCard';

const AdsSalesCard = ({ formattedStart, formattedEnd, selectedIds , selectedTab ,isButtonDisabled,type,permission}) => {
  const { loadingState, categoryPerformanceState, getCategoryPerformanceDashbaord,accessDenied} = useAdsAnalysis();
  const sectionPermissionMap = {
  "Cost Metrics": "cost_metrics",
  "Efficiency Metrics": "efficiency_metrics",
  "Performance Metrics": "performance_metrics",
  "Returns and Quality Metrics": "returns_and_quality_metrics",
  "Sales Metrics": "sales_metrics"
};

  const [showAll, setShowAll] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);
  const [prevData, setPrevData] = useState({});
  const {selectedOption} = useOption();
  const [activeTooltipIndex, setActiveTooltipIndex] = useState(null);
  const isSelectionEmpty =
  (selectedIds?.productId?.length || 0) === 0 &&
  (selectedIds?.categoryId?.length || 0) === 0;

  useEffect(() => {
    getCategoryPerformanceDashbaord({ formattedEnd, formattedStart , selectedTab });
  }, [formattedStart, formattedEnd , selectedTab,selectedOption?.id]);

  useEffect(() => {
    if (isButtonDisabled) {
      getCategoryPerformanceDashbaord({ formattedEnd, formattedStart, selectedIds, selectedTab});
    }
  }, [isButtonDisabled,isSelectionEmpty]);

  useEffect(() => {
    if (!loadingState?.categoryPerformanceState && categoryPerformanceState && Object.keys(categoryPerformanceState).length > 0) {
      setPrevData(categoryPerformanceState);
    }
  }, [loadingState?.categoryPerformanceState, categoryPerformanceState]);

  useEffect(() => {
    const calculateVisibleCount = () => {
      const width = window.innerWidth;
      if (width >= 1800) return 6;
      if (width >= 1600) return 5;
      if (width >= 1400) return 4;
      if (width >= 1200) return 3;
      if (width >= 768) return 2;
      if (width >= 389) return 1;
      return 2;
    };

    const updateVisibleCount = () => setVisibleCount(calculateVisibleCount());
    updateVisibleCount();
    window.addEventListener('resize', updateVisibleCount);
    return () => window.removeEventListener('resize', updateVisibleCount);
  }, []);

  const transformKey = (key) => {
    const keyWithSpaces = key.replace(/_/g, ' ');
    const lowerKey = key.toLowerCase();
     if ((lowerKey.includes("ctr")) || lowerKey.includes("cpc")) {
      return keyWithSpaces.toUpperCase();
    }
    if ((lowerKey.includes("roas") || lowerKey.includes("acos")) && !lowerKey.includes("tacos")) {
      return keyWithSpaces.toUpperCase();
    }
    return keyWithSpaces.split(' ').map(word =>
      word.toLowerCase() === 'tacos' ? 'TACOS' : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };

  const isEmpty = !prevData || Object.keys(prevData).length === 0;

  const toggleTooltip = (index) => {
    setActiveTooltipIndex(prev => (prev === index ? null : index));
  };
  if (accessDenied){
    return(
      <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
      <AllowedCard/>
      </div>
    )
  }


  return (
    <div className="dashboard-grid">
      {isEmpty ? (
        loadingState?.categoryPerformanceState ? (
          Array.from({ length: visibleCount }).map((_, index) => (
            <div className="card p-3 shadow-sm" key={index}>
              <div className="skeleton skeleton-text w-100 mb-2" />
              <div className="skeleton skeleton-text w-75 mb-1" />
              <div className="skeleton skeleton-text w-50" />
            </div>
          ))
        ) : (
      <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
        No data found
      </div>
        )
      ) : (
        <>
        {prevData && (
          <KpiAccordion data={prevData} permission={permission} sectionPermissionMap={sectionPermissionMap} transformKey={transformKey} loadingState={loadingState} dashboardSummary={categoryPerformanceState} toggleTooltip={toggleTooltip} activeTooltipIndex={activeTooltipIndex} setActiveTooltipIndex={setActiveTooltipIndex} type={type} showWithGroupParent={false}/>
        )}
          </>

      )}
    </div>
  );
};

export default AdsSalesCard;
